import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledTable = styled.div`
  width: 100%;
  background: ${COLOR.white};
  border: 0.5px solid ${COLOR.indigo[8]};
  border-radius: ${({ $isMobile }) => ($isMobile ? '12px' : '16px')};
  overflow: hidden;
  box-sizing: border-box;
`;

export const StyledHeaderRow = styled.div`
  display: flex;
  align-items: center;
  height: 56px;
  background: ${COLOR.charcoal};
  border-bottom: 0.5px solid ${COLOR.indigo[8]};
  width: 100%;
  box-sizing: border-box;
`;

export const StyledDataRow = styled.div`
  display: flex;
  align-items: stretch;
  min-height: ${({ $isMobile, $isSubRow }) => {
    if ($isMobile) return '88px';
    return $isSubRow ? '56px' : '52px';
  }};
  background: ${({ $isSubRow }) =>
    $isSubRow ? COLOR.charcoalV2[64] : COLOR.white};
  border-bottom: 0.5px solid ${COLOR.indigo[8]};
  width: 100%;
  box-sizing: border-box;

  &:last-child {
    border-bottom: none;
  }
`;

export const StyledCell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ $isMobile }) => ($isMobile ? '4px' : '0')};
  padding: ${({ $isMobile }) => ($isMobile ? '16px 12px' : '16px')};
  border-right: 0.5px solid ${COLOR.indigo[8]};
  box-sizing: border-box;

  &:last-child {
    border-right: none;
  }

  &.col-name {
    width: 200px;
    flex-shrink: 0;
    align-items: ${({ $isSubRow }) => ($isSubRow ? 'stretch' : 'flex-start')};
    text-align: left;
    min-width: 0;
    padding-right: 4px;
    overflow-wrap: anywhere;
  }

  &.col-cost {
    width: ${({ $isMobile }) => ($isMobile ? 'auto' : '200px')};
    flex: ${({ $isMobile }) => ($isMobile ? '1' : 'none')};
    flex-shrink: 0;
    align-items: flex-start;
    text-align: left;
  }

  &.col-description {
    flex: 1;
    min-width: 0;
    align-items: flex-start;
    justify-content: center;
    text-align: left;
  }

  &.is-header {
    justify-content: center;
    align-items: flex-start;
  }
`;

export const StyledCellText = styled.p`
  margin: 0;
  font-family: 'SF Pro Text', sans-serif;
  font-weight: ${({ $isHeader }) => ($isHeader ? '600' : '400')};
  font-style: ${({ $isItalic }) => ($isItalic ? 'italic' : 'normal')};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: ${({ $isDim }) => ($isDim ? COLOR.label2[64] : COLOR.label2[100])};
  overflow-wrap: anywhere;
  word-break: break-word;
  min-width: 0;
`;

export const StyledCellDescription = styled.p`
  margin: 0;
  font-family: 'SF Pro Text', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.4px;
  color: ${COLOR.label2[64]};
`;

export const StyledSubRowList = styled.ul`
  list-style: disc;
  margin: 0;
  padding-left: 21px;
  text-align: left;
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;

  li {
    padding-left: 0;
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
`;
